import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import {
  ArchivingTypeEnum,
  TabMenuManagement,
} from "../../constants/AppConstants";
import { OptionItem } from "../../components/TextSwitch/TextSwitch";
import { FilterProps } from "../../types/AppTypes";

export interface InitialStateProps {
  tabsManagement: TabMenuManagement | null;
  tabsManagementArchiving: OptionItem<ArchivingTypeEnum> | null;
  searchValueReadySendSheet: string;
  selectedPracticeReadySendSheet: string | null;
  searchPracticeValueReadySendSheet: string;
  pageNumberReadySendSheet: number;
  searchValuePendingFinalFeedback: string;
  selectedPracticePendingFinalFeedback: string | null;
  searchPracticeValuePendingFinalFeedback: string;
  pageNumberPendingFinalFeedback: number;
  searchActiveResources: string;
  filtersActiveResources: FilterProps[];
  pageNumberActiveResources: number;
}

export const initialState: InitialStateProps = {
  tabsManagement: null,
  tabsManagementArchiving: null,
  searchValueReadySendSheet: "",
  selectedPracticeReadySendSheet: null,
  searchPracticeValueReadySendSheet: "",
  pageNumberReadySendSheet: 0,
  searchValuePendingFinalFeedback: "",
  selectedPracticePendingFinalFeedback: null,
  searchPracticeValuePendingFinalFeedback: "",
  pageNumberPendingFinalFeedback: 0,
  searchActiveResources: "",
  filtersActiveResources: [],
  pageNumberActiveResources: 0,
};

export const managementSlice = createSlice({
  name: "managements",
  initialState,
  reducers: {
    setTabsManagement: (
      state: InitialStateProps,
      action: PayloadAction<TabMenuManagement>,
    ) => {
      state.tabsManagement = action.payload;
    },
    setTabsManagementArchiving: (
      state: InitialStateProps,
      action: PayloadAction<OptionItem<ArchivingTypeEnum>>,
    ) => {
      state.tabsManagementArchiving = action.payload;
    },
    setSearchValueReadySendSheet: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchValueReadySendSheet = action.payload;
    },
    setSelectedPracticeReadySendSheet: (
      state: InitialStateProps,
      action: PayloadAction<string | null>,
    ) => {
      state.selectedPracticeReadySendSheet = action.payload;
    },
    setSearchPracticeValueReadySendSheet: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchPracticeValueReadySendSheet = action.payload;
    },
    setSearchValuePendingFinalFeedback: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchValuePendingFinalFeedback = action.payload;
    },
    setSelectedPracticePendingFinalFeedback: (
      state: InitialStateProps,
      action: PayloadAction<string | null>,
    ) => {
      state.selectedPracticePendingFinalFeedback = action.payload;
    },
    setSearchPracticeValuePendingFinalFeedback: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchPracticeValuePendingFinalFeedback = action.payload;
    },
    setPageNumberReadySendSheet: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.pageNumberReadySendSheet = action.payload;
    },
    setPageNumberPendingFinalFeedback: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.pageNumberPendingFinalFeedback = action.payload;
    },
    setSearchActiveResources: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchActiveResources = action.payload;
    },
    setFiltersActiveResources: (
      state: InitialStateProps,
      action: PayloadAction<FilterProps[]>,
    ) => {
      state.filtersActiveResources = action.payload;
    },
    setPageNumberActiveResources: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.pageNumberActiveResources = action.payload;
    },
    resetManagementState: () => initialState,
  },
});

export const {
  setTabsManagement,
  setTabsManagementArchiving,
  setSearchValueReadySendSheet,
  setSelectedPracticeReadySendSheet,
  setSearchPracticeValueReadySendSheet,
  setPageNumberReadySendSheet,
  setSearchValuePendingFinalFeedback,
  setSelectedPracticePendingFinalFeedback,
  setSearchPracticeValuePendingFinalFeedback,
  setPageNumberPendingFinalFeedback,
  setSearchActiveResources,
  setFiltersActiveResources,
  setPageNumberActiveResources,
  resetManagementState,
} = managementSlice.actions;
export default managementSlice.reducer;
